import { createAction, handleActions } from 'redux-actions';
import { parseDuplicateParameters } from '../../utility/uiUtils';
import { replaceObjectInList } from '../../utility/helpers';
import http from '../../utility/http';
import {
  API_CANDIDATES,
  API_CANDIDATES_ALL,
  api_candidates_in_job,
  API_JOBS,
  API_JOBS_ARCHIVED,
  API_JOBS_BASIC,
} from '../../constants/apiRoutes';
// ------------------------------------
// Constants
// ------------------------------------

const SET_JOBS = 'SET_JOBS';
const SET_ALL_JOBS = 'SET_ALL_JOBS';
const SET_CANDIDATES = 'SET_CANDIDATES';
const SET_ALL_CANDIDATES = 'SET_ALL_CANDIDATES';
const LOAD_MORE_JOBS = 'LOAD_MORE_JOBS';
const LOAD_MORE_CANDIDATES = 'LOAD_MORE_CANDIDATES';
const UPDATE_CANDIDATE = 'UPDATE_CANDIDATE';

const initialState = {
  jobs: [],
  candidates: [],
  allCandidates: [],
  allJobs: [],
};

// ------------------------------------
// Actions
// ------------------------------------
const setJobs = createAction(SET_JOBS);
const setAllJobs = createAction(SET_ALL_JOBS);
const setCandidates = createAction(SET_CANDIDATES);
const setAllCandidates = createAction(SET_ALL_CANDIDATES);
const loadMoreJobs = createAction(LOAD_MORE_JOBS);
const loadMoreCandidates = createAction(LOAD_MORE_CANDIDATES);
const updateCandidate = createAction(UPDATE_CANDIDATE);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_JOBS]: (state, { payload }) => {
    return {
      ...state,
      jobs: payload,
    };
  },
  [LOAD_MORE_JOBS]: (state, { payload }) => {
    return {
      ...state,
      jobs: {
        ...payload,
        results: state.jobs.results
          ? [...state.jobs.results, ...payload.results]
          : [...payload.results],
      },
    };
  },
  [SET_CANDIDATES]: (state, { payload }) => {
    return {
      ...state,
      candidates: payload,
    };
  },
  [LOAD_MORE_CANDIDATES]: (state, { payload }) => {
    return {
      ...state,
      candidates: {
        ...payload,
        results: state.candidates.results
          ? [...state.candidates.results, ...payload.results]
          : [...payload.results],
      },
    };
  },
  [SET_ALL_JOBS]: (state, { payload }) => {
    return {
      ...state,
      allJobs: payload,
    };
  },
  [SET_ALL_CANDIDATES]: (state, { payload }) => {
    return {
      ...state,
      allCandidates: payload,
    };
  },
  [UPDATE_CANDIDATE]: (state, { payload }) => {
    if (!Array.isArray(state.candidates)) return state;

    const candidateIndex = state.candidates.findIndex(
      candidate => candidate.id === payload.id
    );

    if (candidateIndex === -1) return state;

    return {
      ...state,
      candidates: replaceObjectInList(state.candidates, candidateIndex, {
        last_update: payload.last_update,
      }),
    };
  },
};

// ------------------------------------
// API calls
// ------------------------------------

export const getJobs = (dispatch, isLoadMore = false, params = {}) => {
  return http
    .get(API_JOBS, {
      params,
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      dispatch(isLoadMore ? loadMoreJobs(data) : setJobs(data));
    });
};

export const getArchivedJobs = (dispatch, isLoadMore = false, params = {}) => {
  return http
    .get(API_JOBS_ARCHIVED, {
      params,
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      dispatch(isLoadMore ? loadMoreJobs(data) : setJobs(data));
    });
};

export const getCandidates = (dispatch, isLoadMore = false, params = {}) => {
  return http
    .get(API_CANDIDATES, {
      params,
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      dispatch(isLoadMore ? loadMoreCandidates(data) : setCandidates(data));
    });
};

export const getAllCandidates = dispatch => {
  return http.get(API_CANDIDATES_ALL).then(({ data }) => {
    dispatch(setAllCandidates(data));
  });
};
export const getCandidatesInStep = (dispatch, jobId, params = {}) => {
  return http
    .get(api_candidates_in_job(jobId), {
      params,
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      dispatch(setCandidates(data));
      return data;
    });
};

export const getAllJobs = (dispatch, params = {}) => {
  return http
    .get(API_JOBS_BASIC, {
      params,
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      dispatch(setAllJobs(data));
    });
};

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearJobs = () => setJobs(initialState.jobs);
export const clearCandidates = () => setJobs(initialState.candidates);
export const clearAllJobs = () => setAllJobs(initialState.allJobs);
export const clearAllCandidates = () =>
  setAllCandidates(initialState.allCandidates);
export const updateCandidateLastUpdate = candidateId =>
  updateCandidate({
    id: candidateId,
    last_update: new Date().toISOString(),
  });
